import { createSlice } from '@reduxjs/toolkit'
import { FirestoreDatabase, storageRef } from '../index'
import { Collection } from 'constants/index'
import { caseInsensitiveSort } from 'utils'
import { signOut } from 'store/auth'

export const initialState = {
  error: null,
  inProgress: false,
  icons: [],
  icon: null,
  currentPage: 0,
  pageSize: 10
}

const iconSlice = createSlice({
  name: 'icon',
  initialState: initialState,
  reducers: {
    setError: (state, action) => {
      state.error = action.payload
    },
    setProgress: (state, action) => {
      state.inProgress = action.payload
    },
    setIcons: (state, action) => {
      state.icons = action.payload
    },
    setIcon: (state, action) => {
      state.icon = action.payload
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload
    }
  },
  extraReducers: {
    [signOut.fulfilled]: (state) => {
      state.error = null
      state.inProgress = false
      state.icons = []
      state.icon = null
      state.currentPage = 0
      state.pageSize = 10
    }
  }
})

export const addIcon = (payload) => async (dispatch) => {
  try {
    dispatch(iconSlice.actions.setProgress(true))
    const doc = await FirestoreDatabase.collection(Collection.EVENT_CARD_STYLES).add(payload)
    return doc.id
  } catch (err) {
    dispatch(iconSlice.actions.setError(err))
  } finally {
    dispatch(iconSlice.actions.setProgress(false))
  }
}

export const fetchIcons = () => async (dispatch, getState) => {
  try {
    const user = getState().auth.user
    dispatch(iconSlice.actions.setProgress(true))
    FirestoreDatabase.collection(Collection.EVENT_CARD_STYLES)
      .where('conferenceId', '==', user?.conferenceId)
      .onSnapshot((documents) => {
        const icons = []
        documents.forEach((doc) => {
          icons.push({
            id: doc.id,
            ...doc.data()
          })
        })
        dispatch(iconSlice.actions.setIcons(caseInsensitiveSort(icons, 'type')))
      })
  } catch (err) {
    dispatch(iconSlice.actions.setError(err))
  } finally {
    dispatch(iconSlice.actions.setProgress(false))
  }
}

export const fetchIconById = (iconId) => async (dispatch) => {
  try {
    dispatch(iconSlice.actions.setProgress(true))
    const snapshot = await FirestoreDatabase.collection(Collection.EVENT_CARD_STYLES)
      .doc(iconId)
      .get()
    const e = snapshot.data()
    dispatch(
      iconSlice.actions.setIcon({
        id: snapshot.id,
        ...e
      })
    )
  } catch (err) {
    dispatch(iconSlice.actions.setError(err))
  } finally {
    dispatch(iconSlice.actions.setProgress(false))
  }
}

export const updateIconById = (iconId, payload) => async (dispatch) => {
  try {
    dispatch(iconSlice.actions.setProgress(true))
    await FirestoreDatabase.collection(Collection.EVENT_CARD_STYLES).doc(iconId).update(payload)
    return iconId
  } catch (err) {
    dispatch(iconSlice.actions.setError(err))
  } finally {
    dispatch(iconSlice.actions.setProgress(false))
  }
}

export const checkCardExistsInEvents = (cardId) => async (dispatch, getState) => {
  try {
    dispatch(iconSlice.actions.setProgress(true))
    const user = getState().auth.user
    const snapshot = await FirestoreDatabase.collection(Collection.EVENTS)
      .where('cardStyle', '==', cardId)
      .where('conferenceId', '==', user?.conferenceId)
      .get()

    return !snapshot.empty
  } catch (err) {
    dispatch(iconSlice.actions.setError(err))
  } finally {
    dispatch(iconSlice.actions.setProgress(false))
  }
}

export const deleteIconById = (conferenceId, iconId) => async (dispatch) => {
  try {
    dispatch(iconSlice.actions.setProgress(true))
    const snapshot = await FirestoreDatabase.collection(Collection.EVENT_CARD_STYLES)
      .doc(iconId)
      .get()
    const e = snapshot.data()
    try {
      await storageRef
        .child(`${conferenceId}/${Collection.EVENT_CARD_STYLES}/${e.imageName}`)
        .delete()
    } catch (e) {
      // do nothing
    }
    FirestoreDatabase.collection(Collection.EVENT_CARD_STYLES).doc(iconId).delete()
  } catch (err) {
    dispatch(iconSlice.actions.setError(err))
  } finally {
    dispatch(iconSlice.actions.setProgress(false))
  }
}

export const resetIcon = () => (dispatch) => {
  dispatch(iconSlice.actions.setIcon(null))
}

export default iconSlice
